import { NonFlexingContainer, PollabOption } from '@sport1/news-styleguide'
import React, { FC, useEffect, useState } from 'react'
import { IOption } from '../../../../../api/types'
import { calculatePercent } from '../../../../../utils/calculatePercent'
import { RenderOption } from '../types'

type Props = {
    options: IOption[]
    disable: boolean
    votesCount?: number
    votesStored: string[]
    onVote: (key: string) => void
}

const OptionListSection: FC<Props> = ({ options, votesCount, votesStored, disable, onVote }) => {
    const [optionRender, setOptionRender] = useState<RenderOption[]>([])

    useEffect(() => {
        const percents = calculatePercent(
            options.map(option => option.votes || 0),
            votesCount
        )

        const _options = options.map(({ votes, title, uuid }, index) => {
            const isVoted = !isNaN(Number(votes))
            const result = isVoted && percents[index] >= 0 ? `${percents[index]}%` : ''
            const percent = percents[index]
            const selected = votesStored.includes(uuid)
            return { uuid, title, result, percent, selected }
        })
        setOptionRender(_options)
    }, [options, votesCount, votesStored])

    return (
        <>
            {optionRender.map(({ uuid, title, percent, selected, result }) => (
                <NonFlexingContainer key={`question-option-${uuid}`} marginY={2}>
                    <PollabOption
                        label={title}
                        disabled={disable}
                        selected={selected}
                        percent={percent}
                        onPress={() => onVote(uuid)}
                        result={result}
                    />
                </NonFlexingContainer>
            ))}
        </>
    )
}

export default OptionListSection
